import { render } from "./MainSection.vue?vue&type=template&id=579fd8ea&scoped=true&ts=true"
import script from "./MainSection.vue?vue&type=script&lang=ts"
export * from "./MainSection.vue?vue&type=script&lang=ts"

import "./MainSection.vue?vue&type=style&index=0&id=579fd8ea&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/jobs/RECA/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579fd8ea"]])

export default __exports__